






import { Component } from 'vue-property-decorator';
import { EventBus } from '../helpers/bus';
import BaseComponent from './Base';

@Component({
    name: 'swiper-slide',
})
export default class SwiperSlide extends BaseComponent {
    protected showOverlay: boolean = true;
    protected isVisibleBeforeChange: boolean = false;

    protected isActiveSlide(): boolean {
        return this.$el.classList.contains('swiper-slide-active');
    }

    protected mounted(): void {
        this.isVisibleBeforeChange = this.isActiveSlide();
        this.$parent.$on('slideChange', () => {
            this.isVisibleBeforeChange = this.isActiveSlide();
        });
        this.$parent.$on('slideChangeTransitionEnd', () => {
            if (!this.isActiveSlide() && this.isVisibleBeforeChange) {
                this.isVisibleBeforeChange = false;
                EventBus.$emit(`slideHidden:${this.uniqId}`);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SwiperSlide.vue